module.exports = __webpack_public_path__ + "public/SiteIcons/popular-right.png?15b0df03";